export default __webpack_public_path__ + "static/media/user-journey-img1.4ea8625d.svg";